import { render, staticRenderFns } from "./custom-body.vue?vue&type=template&id=e70855ec&"
import script from "./custom-body.vue?vue&type=script&lang=js&"
export * from "./custom-body.vue?vue&type=script&lang=js&"
import style0 from "./custom-body.vue?vue&type=style&index=0&id=e70855ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports